export default __webpack_public_path__ + "static/media/black_kindred_icon.06299f94.png";